module.exports = __webpack_public_path__ + "img/product_94.bf373e7.webp";